module.exports = __webpack_public_path__ + "static/17-3f731b2c1e05ca6217734720f2673b3b.jpg";